import { TextField } from '@blueprinthq/joy'
import { Box } from '@chakra-ui/react'
import React from 'react'
import InputMask from 'react-input-mask'

interface BPTimePickerProps {
  value: string
  onChange: (value: string) => void
  onBlur: (e: React.FocusEvent<any>) => void
  errors?: string
}

export const BPTimePicker: React.FC<BPTimePickerProps> = ({
  value,
  onChange,
  onBlur,
  errors
}) => {
  return (
    <Box width="74px">
      <InputMask
        mask="99:99 aa"
        value={value}
        onChange={(e: any) => {
          onChange(e.target.value)
        }}
        onBlur={onBlur}
        maskChar="_"
      >
        {(inputProps: any) => (
          <TextField
            {...inputProps}
            width="100%"
            bg="white"
            borderColor="rgba(87, 89, 91, 0.04)"
            borderWidth="0px 0px 1px 0px"
            padding="0px"
            _focus={{
              borderColor: 'primary',
              borderWidth: '0px 0px 2px 0px'
            }}
            isInvalid={!!errors}
          />
        )}
      </InputMask>
    </Box>
  )
}
